export default "__VITE_ASSET__289dab61__"